var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"c-about-mycolor"},[_vm._v("\n  アカウントサービスはMyColorが提供しています。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }